import { ChefHat } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface RecipeEquipmentCardProps {
  equipment: string[]
}

export function RecipeEquipmentCard({ equipment }: RecipeEquipmentCardProps) {
  if (equipment.length === 0) {
    return null
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <ChefHat className="mr-2 h-5 w-5" />
          Benodigde apparatuur
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {equipment.map((item, index) => (
            <li key={index} className="flex items-center text-gray-700">
              <span className="mr-3 h-2 w-2 rounded-full bg-gray-400"></span>
              {item}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
